import repositories from '..';

const resource = '/master/commune';

export default {
  get: (data: any) => repositories.get(`${resource}?districtId=${data}`),
};
